
import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME, CRUMB_LABEL_EDIT } from '../constants';
import { apiProvider } from '../api';
import { editMutationsNames } from './constants';

const edit = {
	DuvodPrp: null as boolean | null,
	IntrDruhOzn: null as number | null,
	KontoNr: null as number | null,
	ProvozovnaId: null as number | null,
	StrednaklOzn: null as number | null,
	StrednaklOznText: null as String | null,
	Text: null as string | null,
	VozidloPrp: null as boolean | null,
	VyrazenPrp: null as boolean | null,
	ZakaznikSk: null as number | null,
	ZaznamId: null as number | null,
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_EDIT,
	dropdownList: {
		ProvozovnaId: [],
		ZakaznikSk: [],
	},
	depTableNames: [],
	depTableSettings: {},
	edit,
	localState: {},
	extraActions: {},
	extraMutations: {
		[editMutationsNames.NAKLADOVE_STREDISKO_SELECT_MAPPER](state, { data }) {
			state.edit.StrednaklOzn = data.value;
			state.edit.StrednaklOznText = data.text;
			if (!data.isClear) {
				state.edit.ProvozovnaId = data.provozovnaId;
			}
		},
	},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
